export default "__VITE_ASSET__$ZHygx$M__"